<!-- CHOOSE AN APPOINTMENT TIME -->
<div class="content-panel">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">

      <h2 translate>SCHEDULE_INTERVIEW.TIME.BANNER</h2>

      <div class="well appointment-summary">
        <dl class="list-inline">
          <dt translate>SCHEDULE_INTERVIEW.LOCATION_LABEL</dt>
          <dd translate>{{location?.name}}</dd>
          <dt translate>SCHEDULE_INTERVIEW.DATE_LABEL</dt>
          <dd>{{focusDate | date}}</dd>
        </dl>
      </div>


      <!-- HEADER -->
      <div class="appointment-time-header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <span class="time-zone" style = "min-width: 370px;"><span class="fa fa-info-circle"></span> <span translate>SCHEDULE_INTERVIEW.TIME.ZONE.ALL_TIMES_SHOWN_IN</span> <strong translate>{{ location?.tzData }}</strong></span>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <h4><span translate>{{focusMonth}}</span> {{focusDate | date:'y'}}</h4>
          </div>
        </div>
      </div>
      <!-- [end] ~ HEADER -->
    </div>

    <div class="row">
      <div class="col-12 position-relative">
        <a tabindex="0" (click)="prevDay()" (keyup.enter)="prevDay()" [class.dhs-cal-pagination]="totalCols > 1" [class.dhs-cal-pagination-neg]="totalCols == 1" class="left shallow"><span translate>SCHEDULE_INTERVIEW.TIME.PREVIOUS</span></a>
        <a tabindex="0" (click)="nextDay()" (keyup.enter)="nextDay()" [class.dhs-cal-pagination]="totalCols > 1" [class.dhs-cal-pagination-neg]="totalCols == 1" class="right shallow"><span translate>SCHEDULE_INTERVIEW.TIME.NEXT</span></a>
      </div>
    </div>

    <div class="appointment-list">
      @if (dates) {
        <div class="row">
          @for (date of dates; track date) {
            <day-component class="p-0" [date]="date.date" (selectedTime)="onTimeSelected($event)" [isFocusedDay]="date.isFocus" [numberColumns]="totalCols"></day-component>
          }
        </div>
      }
    </div>

  </div>
</div>
<!-- [end] ~ CHOOSE AN APPOINTMENT TIME) -->
